(() => {
  const init=async root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const catalog=JSON.parse(root.querySelector('[data-catalog]').textContent);
    const m=JSON.parse(root.querySelector('[data-messages]').textContent);
    const list=root.querySelector('[data-items]');
    const status=root.querySelector('[data-status]');
    const dialog=root.querySelector('dialog');
    const grid=dialog.querySelector('[data-dialog-grid]');
    const base=root.dataset.root.replace(/\/?$/,'/');
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:root.dataset.currency||'AED'}).format(cents/100);
    let rows=[],preset={},busy=true;
    const el=(tag,cls,text)=>{const node=document.createElement(tag);if(cls)node.className=cls;if(text!==undefined)node.textContent=text;return node;};
    const photo=v=>{const img=el('img');img.src=v.image;img.alt=v.variant;img.width=180;img.height=180;img.loading='lazy';return img;};
    const btn=(text,cls,fn,aria)=>{const b=el('button',cls,text);b.type='button';b.disabled=busy;if(aria)b.setAttribute('aria-label',aria);b.addEventListener('click',fn);return b;};
    const update=(notice='',focusVariant=null,renderRows=true)=>{
      const focusLabel=root.contains(document.activeElement)?document.activeElement.getAttribute('aria-label'):null;
      const result=BibadoBundle.calculate(rows,catalog);
      if(renderRows){
        rows=result.lines.map(l=>({id:l.id,qty:l.qty}));
        list.replaceChildren();
        if(!rows.length){const empty=el('div','hm-empty');empty.append(el('h3','',m.empty_title),el('p','',m.empty_body));list.append(empty);}
      }
      for(const row of renderRows?rows:[]){
        const v=catalog.find(v=>v.id===row.id);
        const item=el('article','hm-item');
        const image=el('div','hm-item-photo');image.append(photo(v));
        const info=el('div');info.append(el('h3','',v.name),el('span','hm-item-variant',v.variant));
        const change=btn(m.change,'hm-text-button',()=>chooseVariant(v.group,row.id),m.change+': '+v.name+' — '+v.variant);
        change.dataset.changeId=v.id;info.append(change);
        const side=el('div');side.append(el('div','hm-item-price',money(v.price*row.qty)));
        const stepper=el('div','hm-qty');
        const setQty=n=>{row.qty=n;update();};
        const minus=btn('−','',()=>setQty(row.qty-1),m.decrease+': '+v.name+' — '+v.variant);
        const input=el('input');input.type='number';input.inputMode='numeric';input.min=0;input.max=v.max;input.step=1;input.value=row.qty;input.disabled=busy;input.setAttribute('aria-label',m.quantity+': '+v.name+' — '+v.variant);input.addEventListener('change',()=>setQty(Number(input.value)));
        input.addEventListener('input',()=>{row.qty=Number(input.value);side.querySelector('.hm-item-price').textContent=money(v.price*Math.min(v.max,Math.max(0,Math.floor(row.qty)||0)));update('',null,false);});
        const plus=btn('+','',()=>setQty(row.qty+1),m.increase+': '+v.name+' — '+v.variant);plus.disabled=busy||row.qty>=v.max;
        stepper.append(minus,input,plus);side.append(stepper,btn(m.remove,'hm-text-button hm-item-remove',()=>setQty(0),m.remove+': '+v.name+' — '+v.variant));
        item.append(image,info,side);list.append(item);
      }
      root.querySelector('[data-subtotal]').textContent=money(result.subtotal);
      root.querySelector('[data-original]').textContent=money(result.original);
      root.querySelector('[data-sale-saving]').textContent='−'+money(result.saleSaving);
      root.querySelector('[data-total-saving]').textContent=money(result.totalSaving);
      root.querySelector('[data-saving]').textContent='−'+money(result.saving);
      root.querySelectorAll('[data-total]').forEach(n=>n.textContent=money(result.total));
      root.querySelector('[data-count]').textContent=result.count+' '+m.selected;
      root.querySelectorAll('[data-buy]').forEach(b=>{b.disabled=busy||!result.eligible;b.textContent=busy?m.adding:(b.closest('.hm-mobile-buy')?m.add_cart:m.add_bundle)+' ↗';});
      root.querySelector('[data-add-item]').disabled=busy;root.querySelector('[data-restore]').disabled=busy;root.querySelector('[data-clear]').disabled=busy;
      status.textContent=notice||(!result.eligible?m.minimum:'');
      if(renderRows&&(focusVariant||focusLabel)){
        const match=focusVariant?[...root.querySelectorAll('[data-change-id]')].find(n=>n.dataset.changeId===focusVariant):[...root.querySelectorAll('[aria-label]')].find(n=>n.getAttribute('aria-label')===focusLabel&&!n.disabled);
        (match||root.querySelector('[data-add-item]')).focus({preventScroll:true});
      }
      return result;
    };
    const open=title=>{dialog.querySelector('h2').textContent=title;grid.replaceChildren();if(!dialog.open)dialog.showModal();};
    const chooseVariant=(group,replaceId=null)=>{
      open(m.choose_variant);
      for(const v of catalog.filter(v=>v.group===group)){
        const b=btn('','hm-dialog-choice',()=>{
          if(replaceId){const row=rows.find(r=>r.id===replaceId);if(row)row.id=v.id;}
          else rows.push({id:v.id,qty:1});
          dialog.close();update('',v.id);
        },v.name+' — '+v.variant);
        b.disabled=!v.available||v.max<1;
        b.append(photo(v),el('strong','',v.variant),el('small','',v.available?money(v.price):m.sold_out));grid.append(b);
      }
      (grid.querySelector('button:not(:disabled)')||root.querySelector('[data-close]')).focus();
    };
    root.querySelector('[data-add-item]').addEventListener('click',()=>{
      open(m.choose_item);
      for(const group of [...new Set(catalog.map(v=>v.group))]){
        const v=catalog.find(v=>v.group===group&&v.available)||catalog.find(v=>v.group===group);
        const b=btn('','hm-dialog-choice',()=>chooseVariant(group),v.groupLabel);b.append(photo(v),el('strong','',v.groupLabel));grid.append(b);
      }
    });
    root.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    const reset=()=>{
      rows=[];
      for(const [group,qty] of Object.entries(preset)){
        let left=qty;
        for(const v of catalog.filter(v=>v.group===group&&v.available)){
          const n=Math.min(left,v.max);if(n>0)rows.push({id:v.id,qty:n});left-=n;if(!left)break;
        }
      }
      update();
    };
    root.querySelector('[data-restore]').addEventListener('click',reset);
    root.querySelector('[data-clear]').addEventListener('click',()=>{rows=[];update();});
    const add=async()=>{
      if(busy)return;
      let result=BibadoBundle.calculate(rows,catalog);if(!result.eligible)return;
      busy=true;update();
      try{
        const selected=result.lines.map(l=>catalog.find(v=>v.id===l.id));
        const handles=[...new Set(selected.map(v=>v.handle))];
        const products=await Promise.all(handles.map(async h=>{const r=await fetch(base+'products/'+encodeURIComponent(h)+'.js',{cache:'no-store'});if(!r.ok)throw Error(m.error);return r.json();}));
        let changed=false;
        for(const v of selected){
          const fresh=products.flatMap(p=>p.variants).find(f=>String(f.id)===v.id);
          if(!fresh||!fresh.available){v.available=false;changed=true;}
          else {if(fresh.price!==v.price||Number(fresh.compare_at_price||fresh.price)!==v.compareAtPrice)changed=true;v.price=fresh.price;v.compareAtPrice=Number(fresh.compare_at_price||fresh.price);}
        }
        if(changed){busy=false;update(m.changed);return;}
        result=BibadoBundle.calculate(rows,catalog);
        const items=result.lines.map(l=>({id:Number(l.id),quantity:l.qty,properties:{Bundle:root.querySelector('h1').textContent.trim()}}));
        const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const payload=await response.json();
        if(!response.ok)throw Error(payload.description||payload.message||m.error);
        window.location.assign(base+'cart');
      }catch(error){busy=false;update(error.message||m.error);}
    };
    root.querySelectorAll('[data-buy]').forEach(b=>b.addEventListener('click',add));
    update();
    try{const response=await fetch(root.dataset.presetsUrl);if(!response.ok)throw Error(m.error);const presets=await response.json();preset=presets[root.dataset.preset]||{};busy=false;reset();}
    catch{busy=false;update(m.error);}
  };
  document.querySelectorAll('[data-happy-bundle]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-happy-bundle]').forEach(init));
})();

